import styled from 'styled-components';

export const Root = styled.div`
  clear: both;
  font-size: 0.8em;
  text-align: right;
  padding: 0 15px 9px 15px;
  a:hover {
    opacity: 0.75;
  }
`;
